import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "700px", margin: "40px auto", padding: "0 20px" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "20px" }}>
        Privacy Policy
      </h1>
      <p style={{ marginBottom: "16px" }}>
        CodeKiwi does not collect personal information from students or teachers.
        Session data is temporary and only used for educational purposes.
        We do not share, sell, or store your data beyond the scope of the current session.
      </p>
      <p style={{ fontSize: "0.875rem", color: "gray" }}>Last updated: August 2, 2025</p>
    </div>
  );
}
